import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({ name: 'safeHtml', standalone: true })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    const input = value ?? '';
    const cleanHtml = (DOMPurify as any)?.sanitize?.(input) ?? input; // fallback if DOMPurify not available in tests
    return this.sanitizer.bypassSecurityTrustHtml(cleanHtml);
  }
}
